import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLinkPay = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 24,
	viewBox: "0 0 48 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		id: "Type=Link",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Vector",
			clipPath: "url(#clip0_13_5710_linkPay_dark)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M24.1319 8.64352C24.1319 8.13884 24.5562 7.73242 25.0564 7.73242C25.5566 7.73242 25.9809 8.14331 25.9809 8.64352C25.9809 9.14373 25.57 9.56801 25.0564 9.56801C24.5428 9.56801 24.1319 9.15713 24.1319 8.64352ZM21.3896 7.85747H22.9975V16.8612H21.3896V7.85747ZM25.8692 10.43H24.248V16.8612H25.8692V10.43ZM37.5214 13.4268C38.7407 12.6765 39.5714 11.5599 39.8974 10.4255H38.2762C37.8519 11.5063 36.8827 12.3192 35.8198 12.6631V7.85747H34.1986V16.8612H35.8198V14.1815C37.0569 14.4897 38.035 15.5616 38.37 16.8612H40.0001C39.75 15.4991 38.8211 14.2217 37.5214 13.4312V13.4268ZM28.7409 11.149C29.1652 10.5863 29.9915 10.2558 30.6659 10.2558C31.9164 10.2558 32.9525 11.1714 32.957 12.5559V16.8568H31.3358V12.9132C31.3358 12.346 31.0812 11.6894 30.2639 11.6894C29.2992 11.6894 28.7454 12.5469 28.7454 13.5474V16.8657H27.1242V10.4344H28.7454V11.149H28.7409Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M13.3594 17.7188C16.3204 17.7188 18.7188 15.3204 18.7188 12.3594C18.7188 9.39833 16.3204 7 13.3594 7C10.3983 7 8 9.39833 8 12.3594C8 15.3204 10.3983 17.7188 13.3594 17.7188Z",
					fill: "#00D66F"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_4",
					d: "M13.1139 9.1438H11.4614C11.783 10.4881 12.7209 11.6359 13.8955 12.3594C12.7164 13.0829 11.783 14.2307 11.4614 15.5751H13.1139C13.5248 14.3335 14.6592 13.2527 16.0526 13.0294V11.685C14.6592 11.4662 13.5248 10.3854 13.1139 9.1438Z",
					fill: "#011E0F"
				})
			]
		})
	}) }), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_13_5710_linkPay_dark",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 10.7188,
			fill: "white",
			transform: "translate(8 7)"
		})
	}) })]
});
export default SvgLinkPay;
